export default "__VITE_ASSET__Bu86MX19__"